import { TLinkField, TStringField } from '../../../types/sitecore.types';
import { TNewsFields, TNewsParams, TNewsProps, TSocialLink } from '../types/news.types';
import { TNewsCardProps } from '../components/newsCard/types/newsCard.types';
import { THeadingTag } from '../../../types/types';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class NewsModel {
  private readonly fields: null | TNewsFields;
  private readonly params: null | TNewsParams;

  constructor(props: TNewsProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || null;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get subtitle(): TStringField | undefined {
    return this.fields?.subtitle;
  }

  get socialText(): TStringField | undefined {
    return this.fields?.socialText;
  }

  get AllNews(): TLinkField | undefined {
    return this.fields?.allNews;
  }

  get socialLinks(): TSocialLink[] {
    return (this.fields?.items?.[1]?.fields?.items || []) as TSocialLink[];
  }

  get cards(): TNewsCardProps[] {
    return (this.fields?.items?.[0]?.fields?.items || []) as TNewsCardProps[];
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
